import { Component, OnInit,OnDestroy } from '@angular/core';


import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit,OnDestroy {
  scroll$: Subscription;
  startPosition: number;
  state:boolean=true;
  constructor() { }

  ngOnInit(): void {
    this.startPosition = window.scrollY;

    this.scroll$ = fromEvent(window, 'scroll').subscribe(e => {
      const currentPosition = window.scrollY;

      if(this.startPosition > currentPosition) {
     this.state=true;

      } else {
       this.state=false;

      }
      this.startPosition = currentPosition
    });
  }
  ngOnDestroy() {
    this.scroll$.unsubscribe()
  }
}
